import {
  CANDIDATE_CandidateSkills_UPDATE_REQUEST,
  CANDIDATE_CandidateSkills_UPDATE_SUCCESS,
  CANDIDATE_CandidateSkills_UPDATE_FAIL,
  DELETE_SKILLS_REQUEST,
  DELETE_SKILLS_SUCCESS,
  DELETE_SKILLS_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  error: null,
  success: false,
  skills: null
};

const candidateSkillUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_CandidateSkills_UPDATE_REQUEST:
    case DELETE_SKILLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case CANDIDATE_CandidateSkills_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        skills: action.result
      };
    case DELETE_SKILLS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        skills: action.result
      };
    case CANDIDATE_CandidateSkills_UPDATE_FAIL:
    case DELETE_SKILLS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false
      };
    default:
      return state;
  }
};

export default candidateSkillUpdateReducer;